import { controls } from "../../controls";
const dashmenu = {
  label: "dashmenu",
  starting: true,
  url: "dashmenu",
  pageLabel: "dashmenu",
  pageType: "history",
  // filteraction: true,
  filter: [
  
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "dashmenu",
    filterable: true,
    sortable: true,
    textReportProps: {
      'LBS': {
        filename: `dashmenu-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    defaultsTo:0,
    displayColumns: [
      {
        Header: "Form Code",
        accessor: "form_code",
      },
      {
        Header: "Form Display",
        accessor: "form_display",
      },
      {
        Header: "Custom Fash Path",
        accessor: "custom_fast_path",
      },
   
    ]
  }
};
export default dashmenu;